import axios from 'axios/index';

const METHOD_POST = 'POST';
const METHOD_GET = 'GET';

class DashboardApi {
  /**
   * @param {string} url
   * @param {number} timeout
   */
  constructor (url, timeout) {
    this.url = url;
    this.timeout = timeout;
  }

  /**
   * @param {string} username
   * @param {string} password
   * @returns {Promise<*>}
   */
  async logIn(username, password) {
    const data = { username, password };

    return this.makeRequest(METHOD_POST, 'login', null, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async logOut(token) {
    return this.makeRequest(METHOD_POST, 'logout', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getProfile(token) {
    return this.makeRequest(METHOD_GET, 'profile', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getTimes(token) {
    return this.makeRequest(METHOD_GET, 'times', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getHealth(token) {
    return this.makeRequest(METHOD_GET, 'health', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getRecommendations(token) {
    return this.makeRequest(METHOD_GET, 'recommendations', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getContacts(token) {
    return this.makeRequest(METHOD_GET, 'contacts', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getPrescriptions(token) {
    return this.makeRequest(METHOD_GET, 'prescriptions', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getHealthStatus(token) {
    return this.makeRequest(METHOD_GET, 'health/status', token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @param {Date} startDate
   * @returns {Promise<*>}
   */
  async startPrescription(token, id, startDate) {
    return this.makeRequest(METHOD_POST, `prescriptions/${id}`, token, { startDate });
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async setBoughtPrescription(token, id) {
    return this.makeRequest(METHOD_POST, `prescriptions/${id}/bought/set`, token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async unsetBoughtPrescription(token, id) {
    return this.makeRequest(METHOD_POST, `prescriptions/${id}/bought/unset`, token);
  }

  /**
   * @param {string} method
   * @param {string} path
   * @param {string} token
   * @param params
   * @returns {Promise<*>}
   */
  async makeRequest(method, path, token, params) {
    const url = `${this.url}/${path}`;
    const headers = { 'Content-Type': 'application/json' };

    if (typeof token === 'string') {
      headers['Authorization'] = token;
    }

    const config = {
      method,
      url,
      responseType: 'json',
      headers,
      data: params,
    };

    const response = await axios(config);

    return response.data;
  }
}


export default DashboardApi;
